var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_485_595)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_485_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 3.99996C10.5267 3.99996 12.78 5.41996 13.88 7.66663C12.78 9.91329 10.5267 11.3333 8 11.3333C5.47333 11.3333 3.22 9.91329 2.12 7.66663C3.22 5.41996 5.47333 3.99996 8 3.99996ZM8 2.66663C4.66667 2.66663 1.82 4.73996 0.666666 7.66663C1.82 10.5933 4.66667 12.6666 8 12.6666C11.3333 12.6666 14.18 10.5933 15.3333 7.66663C14.18 4.73996 11.3333 2.66663 8 2.66663ZM8 5.99996C8.92 5.99996 9.66667 6.74663 9.66667 7.66663C9.66667 8.58663 8.92 9.33329 8 9.33329C7.08 9.33329 6.33333 8.58663 6.33333 7.66663C6.33333 6.74663 7.08 5.99996 8 5.99996ZM8 4.66663C6.34667 4.66663 5 6.01329 5 7.66663C5 9.31996 6.34667 10.6666 8 10.6666C9.65333 10.6666 11 9.31996 11 7.66663C11 6.01329 9.65333 4.66663 8 4.66663Z",
    fill: "#FFF7EB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_485_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_485_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/openEye.a849582255dcf61f03a7cf11067c3ffd.svg";
export { ForwardRef as ReactComponent };